var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('p',[_vm._t("default",[_vm._v("当該メモの詳細情報を取得できませんでした。管理者に確認してください。")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }